// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import EmpruntService from '../../services/EmpruntService';
import LivreService from '../../services/LivreService';
import EleveService from '../../services/EleveService';

const OffcanvasAddEmpruntForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [LivreOptions, setLivreOptions] = useState([]);
	const [EleveOptions, setEleveOptions] = useState([]);

	useEffect(() => {
		const fetchLivreOptions = async () => {
			try {
				const Livres = await LivreService.getLivreOptions();
				setLivreOptions(Livres);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchLivreOptions();
	}, []);

	const Livre_CHOICES = LivreOptions;

	useEffect(() => {
		const fetchEleveOptions = async () => {
			try {
				const Eleves = await EleveService.getEleveOptions();
				setEleveOptions(Eleves);
			} catch (error) {
				console.error('Error fetching Eleve options', error);
			}
		};

		fetchEleveOptions();
	}, []);

	const Eleve_CHOICES = EleveOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const empruntData = new FormData();

				// Add all your form data to the FormData
				empruntData.append('date_emprunt', form.date_emprunt.value);
				empruntData.append('date_retour_prevue', form.date_retour_prevue.value);
				empruntData.append('livre', form.livre.value);
				empruntData.append(
					'date_retour_effective',
					form.date_retour_effective.value
				);
				empruntData.append('eleve', form.eleve.value);

				// Call the EmpruntService to create the Emprunt
				const response = await EmpruntService.createEmprunt(empruntData);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of BulletinnotesClasses
				window.location.href = '/services/bibliotheque/emprunts';
			} catch (error) {
				console.error("Erreur lors de la création de l'emprunt", error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				<Col xs={12} className="mb-3">
					{/* date_emprunt et date_retour_prevue  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="date_emprunt">
									Date de l'Emprunt <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="date_emprunt"
									type="date"
									placeholder="Saisir le date de l'Emprunt"
									id="date_emprunt"
									required
									isInvalid={!!feedbackMessages['date_emprunt']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											date_emprunt: e.target.value
												? ''
												: "La date de l'Emprunt est requis."
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_emprunt']}
								</Form.Control.Feedback>
							</Col>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="date_retour_prevue">
									Date de retour prevue <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="date_retour_prevue"
									type="date"
									placeholder="Saisir la Date de retour prevue de  l'Emprunt"
									id="date_retour_prevue"
									required
									isInvalid={!!feedbackMessages['date_retour_prevue']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											date_retour_prevue: e.target.value
												? ''
												: 'Le Date de retour prevue est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_retour_prevue']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				{/* livre */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="livre">
							Livre <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="livre"
							required
							isInvalid={!!feedbackMessages['livre']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									livre: e.target.value ? '' : 'Le livre est requis.'
								}));
							}}
						>
							{Livre_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['livre']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* date_retour_effective et eleve  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="date_retour_effective">
									Date de retour effective{' '}
									<span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="date_retour_effective"
									type="date"
									placeholder="Saisir la Date de retour effective "
									id="date_retour_effective"
									required
									isInvalid={!!feedbackMessages['date_retour_effective']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											date_retour_effective: e.target.value
												? ''
												: 'La Date de retour effective est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_retour_effective']}
								</Form.Control.Feedback>
							</Col>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="eleve">eleve</Form.Label>
								<Form.Select
									name="eleve"
									required
									isInvalid={!!feedbackMessages['eleve']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											eleve: e.target.value ? '' : 'Le eleve est requis.'
										}));
									}}
								>
									{Eleve_CHOICES.map((option, index) => (
										<option key={index} value={option.value}>
											{option.label}
										</option>
									))}
								</Form.Select>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['eleve']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddEmpruntForm;
